<div class="sidebar-wrapper">
  <div class="sidebar-container">
    <div id="sidebar" class="col-auto col-md-3 col-xl-2 sidebar-item"
      [ngClass]="{'expanded-sidebar': !helperService.collapsedSidebar, 'collapsed-sidebar': helperService.collapsedSidebar}">
      <div class="d-flex flex-column align-items-center align-items-sm-start sidebar-content">
        <div class="menu-toggle-icon-wrapper w-100">
          <a class="text-decoration-none" id="menuToggleIcon">

            <span class="display-none d-sm-inline">
              <img src="../../../assets/img/app-logo.png" />
            </span>
            <span class="app-name display-none d-sm-inline"> {{ 'APP_NAME' | translate }}</span>
            <span class="app-name app-name--version display-none d-sm-inline"> {{ appVersion }}</span>
            <i [ngClass]="{'bi bi-x-lg fs-4': !helperService.collapsedSidebar, 'bi bi-list fs-4': helperService.collapsedSidebar}"
              (click)="helperService.collapsedSidebar = !helperService.collapsedSidebar"></i>
          </a>
        </div>

        @if (!helperService.collapsedSidebar) {
        <app-global-search [isSidebar]="true"></app-global-search>
        } @else {
        <a href="#" class="nav-link align-middle first-link-wrapper w-100"
          (click)="helperService.collapsedSidebar = false">
          <i class="bi bi-search" title="{{ 'placeholders.search' | translate }}"></i>
        </a>
        }

        <ul class="nav nav-pills flex-column mb-0 align-items-center align-items-sm-start w-100" id="menu">

          @for (item of sidebarConfig; track item) {
          <li attr.class="{{item.class ? 'w-100 ' + item.class : 'w-100'}}">

            @if(!!item.submenu.length) {
            <a href="{{'#' + item.submenuId}}" data-bs-toggle='collapse'
              class="nav-link align-middle first-link-wrapper w-100">
              <i class="{{item.icon}}" title="{{ item.title | translate}}"></i>
              <span class="ms-1 display-none d-sm-inline">{{ item.title | translate}}</span>
              @if (!helperService.collapsedSidebar) {
              <span class="additional-sidebar-icon"><i class="bi bi-chevron-down"></i></span>
              }
            </a>
            <ul class="collapse nav flex-column second-link-wrapper" id="{{item.submenuId}}" data-bs-parent="#menu">
              @for (submenuItem of item.submenu; track submenuItem) {
              <li class="w-100">
                @if(submenuItem.submenuLinkExternal) {
                <a class="nav-link align-middle first-link-wrapper w-100"
                  (click)="navigateToExternalLink(submenuItem.submenuLinkExternal)">
                  <i title="{{submenuItem.submenuTitle | translate}}" class="{{submenuItem.submenuIcon}}"></i> <span
                    class="ms-1 display-none d-sm-inline">{{submenuItem.submenuTitle |
                    translate}}</span>

                  @if(!helperService.collapsedSidebar && item.navigateLink) {
                  <span class="additional-sidebar-icon" routerLink="{{item.navigateLink}}">
                    <i class="bi bi-box-arrow-up-right"></i>
                  </span>
                  }
                </a>
                } @else {
                <a routerLink="{{submenuItem.submenuLink}}" class="nav-link"
                  (click)="helperService.collapsedSidebar = true">
                  <i title="{{ submenuItem.submenuTitle | translate }}" class="{{submenuItem.submenuIcon}}"></i>
                  <span class="display-none d-sm-inline">{{ submenuItem.submenuTitle | translate }}</span>
                </a>
                }
              </li>
              }
            </ul>
            } @else {
            @if(item.popup) {
            <a (click)="openCreateCasePopup()" class="nav-link align-middle first-link-wrapper w-100">
              <i title="{{item.title | translate}}" class="{{item.icon}}"></i> <span
                class="ms-1 display-none d-sm-inline">{{item.title |
                translate}}</span>
            </a>
            } @else if(item.navigateLink) {
            <a class="nav-link align-middle first-link-wrapper w-100"
              (click)="navigateToExternalLink(item.navigateLink)">
              <i title="{{item.title | translate}}" class="{{item.icon}}"></i> <span
                class="ms-1 display-none d-sm-inline">{{item.title |
                translate}}</span>

              @if(!helperService.collapsedSidebar && item.navigateLink) {
              <span class="additional-sidebar-icon" routerLink="{{item.navigateLink}}">
                <i class="bi bi-box-arrow-up-right"></i>
              </span>
              }
            </a>
            } @else if(item.escalate) {
            @if((!sidebarService.ticketEscalationData || !(sidebarService.ticketEscalationData &&
            sidebarService.ticketEscalationData.isEscalated)) && sidebarService.ticketEscalationId) {
            <a (click)="escalateTicket()" class="nav-link align-middle first-link-wrapper w-100">
              <i title="{{item.title | translate}}" class="{{item.icon}}"></i> <span
                class="ms-1 display-none d-sm-inline">{{item.title |
                translate}}</span>
            </a>
            }
            } @else {
            <a routerLink="{{item.link}}" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link align-middle first-link-wrapper w-100" (click)="helperService.collapsedSidebar = true">
              <i title="{{item.title | translate}}" class="{{item.icon}}"></i> <span
                class="ms-1 display-none d-sm-inline">{{item.title |
                translate}}</span>
            </a>
            }

            }
          </li>
          }
        </ul>

        <div class="bottom-section w-100">
          <a class="nav-link align-middle first-link-wrapper w-100"
            (click)="navigateToExternalLink(reportBugIdeaDataRequestLink)">
            <i title="{{ 'label.submit_bug_idea_data_request' | translate }}" class="bi bi-bug"></i> <span
              class="px-2 ms-1 display-none d-sm-inline">{{ 'label.submit_bug_idea_data_request' |
              translate}}</span>

            @if(!helperService.collapsedSidebar) {
            <span class="additional-sidebar-icon">
              <i class="bi bi-box-arrow-up-right"></i>
            </span>
            }
          </a>

          <div class="align-middle w-100 p-0 mt-5">
            <app-user-login [collapsedSidebar]="helperService.collapsedSidebar"></app-user-login>
          </div>
          <div class="align-middle w-100 p-0">
            <app-language-switch [collapsedSidebar]="helperService.collapsedSidebar"></app-language-switch>
            <div class="privacy-policy" [ngClass]="{ 'privacy-policy--collapsed' : helperService.collapsedSidebar }"
              (click)="navigateToExternalLink(privacyPolicyLink)" target="_blank">{{ 'label.privacy_policy' | translate
              }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>